import { fetchAztangofestBookingSessionMe } from './fetchAztangofestBookingSessionMe';

/**
 * Когда в сторе ещё нет `eventBookingId`, но JWT уже есть: читаем привязку с сервера (`GET /azdance/profile/me`).
 * Раньше использовался `PUT …/cart/items` с quantity 0 — маршрут удалён, черновик создаётся через bootstrap участников.
 */
export async function ensureAztangofestDraftBookingFromSession(opts: {
  language: string;
  accessToken: string;
}): Promise<string> {
  const me = await fetchAztangofestBookingSessionMe(opts.language, opts.accessToken);
  const eid = me.eventBookingId?.trim();
  if (!eid) {
    throw new Error(
      'No draft booking on this session yet — complete participant registration (bootstrap) first.',
    );
  }
  return eid;
}
